module.exports = __webpack_public_path__ + "static/media/dispute.056499b1.png";